import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { environment } from '../../../../../environment/environment';
import { TestModeService } from '../../../services/test-mode.service';
import { TitleService } from '../../../services/title.service';

@Component({
  selector: 'app-logo-component',
  standalone: true,
  imports: [RouterLink, TranslocoModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './logo.component.html',
})
export class LogoComponent implements OnInit {
  protected readonly t = inject(TestModeService);

  appName = TitleService.APP_NAME;
  highlightLength = 3;

  environment = environment;

  highlightedPart: string = '';
  remainingPart: string = '';

  ngOnInit(): void {
    this.splitAppName();
  }

  private splitAppName(): void {
    if (!this.appName) {
      this.highlightedPart = '';
      this.remainingPart = '';
      return;
    }

    const length = Math.min(this.highlightLength, this.appName.length);
    this.highlightedPart = this.appName.substring(0, length);
    this.remainingPart = this.appName.substring(length);
  }
}
